import React from "react";
import ReactDOM from "react-dom";
import BenefitPlanPage from "./index";

export default function renderBenefitPlanPage({
  target = "page-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<BenefitPlanPage {...rest} />, domTarget);
  }
}
